import styled from 'styled-components';

export const ConfirmMessage = styled.h3`
  text-align: center;
  position: relative;
  display: block;
`;

export const ContentContainer = styled.div`
  text-align: center;
  position: relative;
  display: block;
  margin: 25px 0;
`;

export const ButtonsContainer = styled.div`
  position: relative;
  margin-top: auto;
  display: block;

  button {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
